import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { DeleteOutline, EditOutlined, LibraryAdd } from "@mui/icons-material";
import { toast } from "react-toastify";
import NormalTable from "../../../Component/NormalTable";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import PartVendorModal from "./PartVendorModal";

const PartVendors = ({ partId, enableDisable }) => {
  const trueDisable = !enableDisable?.edit;
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("Create");
  const [editData, setEditData] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const link = masterAPI["businessParts"].getByPartId;
    await axiosPrivate
      .get(`${link}/${partId}`)
      .then((res) => {
        console.log(res.data, "part vendors result");
        setData(res.data.result || []);
      })
      .catch((e) => {
        console.log(e, "part vendors");
        setData([]);
      });
  };

  const handleAdd = () => {
    setMode("Create");
    setEditData({});
    setOpen(true);
  };

  const handleEdit = (row) => {
    setMode("Edit");
    setEditData(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    getData();
  };

  const handleDelete = async (id) => {
    const deleteLink = masterAPI["businessParts"].delete;
    await axiosPrivate
      .delete(`${deleteLink}/${id}`)
      .then(() => {
        getData();
      })
      .catch((e) => {
        console.log(e, "deleteBusinessPart");
      });
  };

  const confirmDelete = (id) => {
    toast(
      <Grid>
        <Typography sx={{ fontSize: "15px", fontWeight: 600, color: "#797979" }}>
          Are you sure you want to delete?
        </Typography>
        <Grid item container spacing={2}>
          <Grid item>
            <Button
              onClick={() => {
                handleDelete(id);
                toast.dismiss();
              }}
              sx={{ color: "grey", borderColor: "green" }}
              size="small"
              variant="outlined"
            >
              Yes
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => toast.dismiss()}
              sx={{ color: "grey", borderColor: "red" }}
              size="small"
              variant="outlined"
            >
              No
            </Button>
          </Grid>
        </Grid>
      </Grid>,
      {
        closeButton: false,
        autoClose: false,
      },
    );
  };

  const columns = [
    {
      Header: "Vendor Code",
      accessor: "business.code",
    },
    {
      Header: "Vendor Name",
      accessor: "business.businessName",
    },
    {
      Header: "Email",
      accessor: "business.email",
    },
    {
      Header: "Mobile No",
      accessor: "business.mobileNo",
    },
    {
      Header: "Lead Time",
      accessor: "leadTime",
    },
    {
      Header: "Default Supplier",
      accessor: "isDefaultSupplier",
      Cell: ({ cell }) => (
        <Typography sx={{ fontSize: "inherit", fontWeight: "inherit" }}>
          {cell.value ? "Default" : "---"}
        </Typography>
      ),
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ({ cell }) => (
        <Box sx={{ whiteSpace: "nowrap" }}>
          <IconButton
            disabled={trueDisable}
            onClick={() => handleEdit(cell.row.original)}
          >
            <EditOutlined
              sx={{
                fontSize: color.masterEditDelButton,
                color: trueDisable ? "default" : color.masterEditDelButtonColor,
              }}
            />
          </IconButton>
          <IconButton
            disabled={trueDisable}
            onClick={() => confirmDelete(cell.value)}
          >
            <DeleteOutline
              sx={{
                fontSize: color.masterEditDelButton,
                color: trueDisable ? "default" : color.masterEditDelButtonColor,
              }}
            />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <IconButton disabled={trueDisable} onClick={handleAdd}>
          <LibraryAdd />
        </IconButton>
        <Typography>Add</Typography>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <NormalTable data={data} columns={columns} />
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"sm"}>
        <PartVendorModal
          mode={mode}
          editData={editData}
          partId={partId}
          handleCloseClick={handleClose}
        />
      </Dialog>
    </Box>
  );
};

export default PartVendors;
